import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, ref } from 'vue'
import { useRoute } from 'vue-router'
import Ofbu from './ofbu.vue'
import Fbu from './fbu.vue'
import Lbu from './lbu.vue'

const __default__ = { name: 'CustomerAggregationView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const type = ref('')
const route = useRoute()
// 跳转详情
const setDetail = () => {
  const { appId } = route.query
  const status = Number(route.query.status as string)
  // 根据状态判断客户阶段10-19 potential 20-29 contract 30-39 clients
  if (status > 9 && status < 20) {
    type.value = 'potential'
  } else if (status > 19 && status < 30) {
    type.value = 'contract'
  } else if (status > 29 && status < 41) {
    type.value = 'clients'
  }
}
onBeforeMount(() => {
  setDetail()
})

return (_ctx: any,_cache: any) => {
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(route).query.appId === 'cos_fbu')
      ? (_openBlock(), _createBlock(Fbu, {
          key: 0,
          type: type.value
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    (_unref(route).query.appId === 'cos_lbu')
      ? (_openBlock(), _createBlock(Lbu, {
          key: 1,
          type: type.value
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    (_unref(route).query.appId === 'cos_ofbu')
      ? (_openBlock(), _createBlock(Ofbu, {
          key: 2,
          type: type.value
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_cos_footer_button, { hideOk: "" })
  ], 64))
}
}

})